<template>
    <div class="learnlistBox">
        <div v-if="showLoading">
            <van-overlay :show="showLoading"/>
            <div class="loadinglist">
                <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <div v-else class='learnlist'>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=" 一 已经到底了，更多内容即将上线 一 "
                :immediate-check="false"
                ref="list"
                @load="onLoad"
                v-show="examlist.length"
            >
                <ul>
                    <li v-for="(item,index) in examlist" :key="index" @click="toexamDetial(item)">
                        <div class="learning-list-left">
                            <img class="learning-list-left-img" :src="item.coverUrl" alt="">
                            <div class="_clear">
                                <p class="learning-list-left-rules" v-if="item.taskType===1 || item.taskType===2">
                                    <img src="../../../assets/images/learning/rules.png" alt="">
                                    <span>{{taskTypetxt(item.taskType)}}</span>
                                </p>
                            </div>
                            
                        </div>
                        <div class="learning-list-right">
                            <h4>{{item.examName}}</h4>
                            <p class="learning-list-right-time learning-list-right-time1" v-if="item.isLimitTime===1">
                                {{item.startTime | formatTime}} 至 {{item.endTime | formatTime}}
                            </p>
                            <p class="learning-list-right-time learning-list-right-time1" v-if="item.isLimitTime===0">
                                长期有效
                            </p>
                            <p class="learning-list-right-time learning-list-right-time1" >
                                来源：{{item.sourceName}}
                            </p>
                            <p class="learning-list-right-lable1 _clear" :class="item.examType===2?'learning-list-right-lable2':''">
                                <span v-if="frontendConfig == 'true'">{{item.examType | examType}}</span>
                            </p>
                        </div>
                    </li>
                </ul>
            </van-list>
            <div class="noContent" v-if="!examlist.length">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/learning/noContent.png"/>
                <p class="trainging-noContent">您还没有学习内容</p>
            </div>
        </div>
    </div>
    
</template>

<script>
import SDK from '@wd/lowcode-h5'
export default {
    name:'',
    data () {
        return {
            frontendConfig:false,
            showLoading: true,
            loading:false,
            finished:false,
            examparam: {
                pageNum: 1,
                pageSize:20,
            },
            examlist: [],
            loadMoreStatus: "more",
            total: 0,
        };
    },
    created() {
       let frontendConfigList =  SDK.getConfigruation(this).frontendConfig;
       frontendConfigList.map(item=>{
           if(item.key == 'examTag'){
               console.log('item---->777', item)
               this.frontendConfig = item.value;
           }
       })
    },
    components: {
    },
    filters: {
        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.')+' '+val.split(' ')[1].split(':').slice(0,2).join(':')
            }
            
        },
        examType(val) {
            return val === 1 ? '模拟考试' : '正式考核'
        },
    },
    methods: {
        /**
         * 上拉加载
         */
        onLoad() {
            this.examparam.pageNum = this.examparam.pageNum*1 + 1
            this.getExamList('reachBottom')
        },
        toexamDetial(val) {
            this.$router.push({
                path: '/examlistDetails',
                query: {
                    trainId: val.bussinessId,
                    contentId: val.examId,
                    trainItemExamId: val.examId,
                    type:val.type,
                    backType:4,
                }
            })
        },
        selectcheck(value){
            this.examparam={
                pageNum: 1,
                pageSize: 20,
            };
            this.getExamList();
        },
        getExamList(type) {
            let params = this.examparam;
            this.$api.learning
                .findUserExams({ params })
                .then(res => {
                    this.showLoading = false;
                    if(res.data){
                        if (type === "reachBottom") {
                            this.examlist = this.examlist.concat(res.data.list);
                        } else {
                            this.examlist = res.data.list || [];
                        }
                        this.total = res.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        this.finished = res.data.isLastPage;
                    }
                
                });
        },

    },

    mounted(){
         
    },
}

</script>
<style lang='less'>
@import '../css/learnlist.less';
</style>